"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAT_RATE_BOXES = void 0;
const commons_objects_1 = require("@deliverr/commons-objects");
exports.FLAT_RATE_BOXES = [
    {
        name: "USPS_PADDED_ENVELOPE",
        length: 11,
        width: 8,
        height: 0,
        lengthUnit: "in",
        weight: 0.0375,
        weightUnit: "lb",
        type: commons_objects_1.PackagingType.BUBBLE_MAILER,
        cost: 0,
        isDeliverrPackage: false,
    },
    {
        name: "USPS_SMALL_BOX",
        length: 8.96,
        width: 5.44,
        height: 1.75,
        lengthUnit: "in",
        weight: 0.1125,
        weightUnit: "lb",
        type: commons_objects_1.PackagingType.BOX,
        cost: 0,
        isDeliverrPackage: false,
    },
];
//# sourceMappingURL=WarehouseBox.js.map